module.exports = __webpack_public_path__ + "assets/img/thumb-AuditCover.3434d1cf.webp";